import type { AnalyticsUserConfiguration } from "owa-analytics-types";

export default function getConditionalAccessString(userConfiguration: AnalyticsUserConfiguration): string {
    const attachmentPolicy = userConfiguration.AttachmentPolicy || {};
    
    if (attachmentPolicy.ConditionalAccessDirectFileAccessOnPrivateComputersBlocked ||
        attachmentPolicy.ConditionalAccessDirectFileAccessOnPublicComputersBlocked) {
        if (attachmentPolicy.ConditionalAccessWacViewingOnPrivateComputersBlocked ||
            attachmentPolicy.ConditionalAccessWacViewingOnPublicComputersBlocked) {
            return "ReadOnlyPlusAttachmentsBlocked";
        }
        else {
            return "ReadOnly";
        }
    }
    return "None";
}
